import { Alert, Form, FormInstance, Modal } from "antd";
import { useCallback, useMemo, useState } from "react";
import { Footer } from "./components/Footer";
import { FormItems } from "./components/FormItems";
import { MODAL_MASK_COLOR } from "../../lib/constants";
import { useSave } from "./hooks/useSave";
import "./styles.scss";

type EmailModalProps = {
  id: string | null;
  mailingType: 1 | 2 | 3;
  shouldOpen: boolean;
  close: () => void;
  reloadData: () => void;
};

export const EmailModal = ({ id, close, mailingType, shouldOpen, reloadData }: EmailModalProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const [isSaving, setIsSaving] = useState<boolean>(false);

  const [data, setData] = useState<any>(null);

  const [canceled, setCanceled] = useState<boolean>(false);

  const [sendToData, setSendToData] = useState<any>([]);

  const closeModal = useCallback(() => {
    if (!isSaving) {
      form.resetFields();
      setData(null);
      setCanceled(false);
      close();
    }
  }, [close, form, isSaving]);

  const { onSave, setInitialFiles, reschedule, resend } = useSave(
    id,
    form,
    mailingType,
    sendToData,
    closeModal,
    reloadData,
    setIsSaving
  );

  const onCanceled = useCallback(() => {
    reloadData();
    setCanceled(true);
  }, [reloadData]);

  const err: string = useMemo(() => (data ? data.errorMessage : ""), [data]);

  return (
    <Modal
      title="Email Details"
      open={shouldOpen}
      width={600}
      wrapClassName="z-1000 position-fixed"
      maskStyle={{ backgroundColor: MODAL_MASK_COLOR }}
      className="bordered-modal emails-modal"
      centered
      onCancel={closeModal}
      footer={
        <Footer
          form={form}
          data={data}
          close={closeModal}
          mailingType={mailingType}
          onSave={onSave}
          isSaving={isSaving}
          canceled={canceled}
          reschedule={reschedule}
          resend={resend}
        />
      }
      destroyOnClose
    >
      <>
        {data && data.errorMessage && <Alert message={err} showIcon type="error" className="mb-4" />}

        <FormItems
          id={id || ""}
          sendToData={sendToData}
          mailingType={mailingType}
          canceled={canceled}
          form={form}
          data={data}
          setSendToData={setSendToData}
          setInitialFiles={setInitialFiles}
          isSaving={isSaving}
          onCanceled={onCanceled}
          setIsSaving={setIsSaving}
          setData={setData}
        />
      </>
    </Modal>
  );
};
